export default __webpack_public_path__ + "static/media/cs.916a3272.png";